import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { usePermissions } from 'app/utils/hooks/document-permission';

function PermissionRouteComponent({ childrenComponent, requiredPermissions = [], requiredSectionPermissions = [], ...props }) {
  const { documentId, sectionId } = props.match.params;
  const { documentPermissions, sectionPermissions, isLoading } = usePermissions(documentId);

  if (isLoading) return <p>Loading permissions</p>;
  const hasDocumentPermission = requiredPermissions.some((permission) => documentPermissions.includes(permission));
  if (sectionId) {
    const hasSectionPermission = sectionId in sectionPermissions && requiredSectionPermissions.includes(sectionPermissions[sectionId]);
    return hasSectionPermission ? childrenComponent(props) : <Redirect to="/" />;
  } else {
    return hasDocumentPermission ? childrenComponent(props) : <Redirect to="/" />;
  }
}

export const PermissionRoute = ({ childrenComponent, requiredPermissions, requiredSectionPermissions, ...rest }) => (
  <Route
    {...rest}
    children={(props) => (
      <PermissionRouteComponent
        {...props}
        childrenComponent={childrenComponent}
        requiredPermissions={requiredPermissions}
        requiredSectionPermissions={requiredSectionPermissions}
      />
    )}
  />
);
